
const initailState = {
    arr:[],
    nextKey:''
}
const AccountsCollectionVehicle=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_COLLECTION_VEHICLE_DATA':
            return{ 
                arr: state.arr.concat(action.payload),
                nextKey:action.nextKey
            }
        default:
            return state;
    }
}

export default AccountsCollectionVehicle
